module.exports = __webpack_public_path__ + "static/img/icons-gift.fda025be.svg";